<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: 'App',
  created() {
    // 解决 element-plus中ElTable 自动宽度高度导致的「ResizeObserver loop limit exceeded」问题 - start
    const debounce = (fn, delay) => {
      let timer = null;
      return function () {
        let context = this;
        let args = arguments;
        clearTimeout(timer);
        timer = setTimeout(function () {
          fn.apply(context, args);
        }, delay);
      }
    }
    const _ResizeObserver = window.ResizeObserver;
    window.ResizeObserver = class ResizeObserver extends _ResizeObserver{
      constructor(callback) {
        callback = debounce(callback, 16);
        super(callback);
      }
    }
    // 解决 element-plus中ElTable 自动宽度高度导致的「ResizeObserver loop limit exceeded」问题 - end
  }
}
</script>

<style>
</style>
